function BuyWithPrimeReviewsBadge({ sku }) {
  return (
    <div className="buy-with-prime-ratings-container relative m-auto w-full">
      <div
        id="amzn-roa-rating"
        data-site-id="gwfxnozf54"
        data-roa-instance-id="w23suqokp7ni1"
        data-sku={sku}
      />
    </div>
  );
}

export default BuyWithPrimeReviewsBadge;
